import { ITableSettings } from 'api/api';
import { localized } from 'state/i18n';
import { ColumnGeneric } from '../history-table-settings/types';
import { SortingGeneric, TableColumnWidthInfoGeneric } from '../table-settings/types';

export interface InnerPredictionColumns {
	fillLevelWhenEmptied?: number;
	actualEmptiedDate?: Date;
}

export interface OuterPredicitionColumns extends InnerPredictionColumns {
	serialNumber?: string;
}

export interface PredictionColumns {
	outerCollapsible: OuterPredicitionColumns;
	innerCollapsible: InnerPredictionColumns;
	predictionDate: Date;
	predictedDaysUntilFull: number;
	predictedDate: Date;
	predictedFillLevel?: number;
	predictionError?: number;
	actualEmptiedDate: Date; //Dummy column for sorting
}

export type PredictionGroupingDtoKeys = keyof PredictionColumns;

export const allColumns: ColumnGeneric<PredictionGroupingDtoKeys>[] = [
	{ name: 'outerCollapsible', title: localized('DeviceGrouping') },
	{ name: 'innerCollapsible', title: localized('PredictionGrouping') },
	{ name: 'actualEmptiedDate', title: '' }, //Dummy column for sorting purposes
	{ name: 'predictionDate', title: localized('PredictionDate') },
	{ name: 'predictedDaysUntilFull', title: localized('PredictedDaysUntilFull') },
	{ name: 'predictedDate', title: localized('PredictedFullDate') },
	{ name: 'predictedFillLevel', title: 'Predited fill level' },
	{ name: 'predictionError', title: 'Error in days' },
];

export const predictionDateColumns: PredictionGroupingDtoKeys[] = [
	'predictedDate',
	'actualEmptiedDate',
	'predictionDate',
];

export const predictionAmountOfDaysColumns: PredictionGroupingDtoKeys[] = ['predictedDaysUntilFull', 'predictionError'];

export interface PredictionTableSettingsState {
	columnWidths: TableColumnWidthInfoGeneric<PredictionGroupingDtoKeys>[];
	columnOrder: PredictionGroupingDtoKeys[];
	sorting: SortingGeneric<PredictionGroupingDtoKeys>[];
	columns: ColumnGeneric<PredictionGroupingDtoKeys>[];
	tableSettings: ITableSettings;
	loaded: boolean;
}
